module.exports = __webpack_public_path__ + "static/media/report1.d14cb7f9.pdf";